/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as MenuIndexRouteImport } from './routes/menu/index'
import { Route as DishesIndexRouteImport } from './routes/dishes/index'
import { Route as AvailabilityIndexRouteImport } from './routes/availability/index'
import { Route as UsersIdRouteImport } from './routes/users/$id'
import { Route as DishesNewRouteImport } from './routes/dishes/new'
import { Route as DishesDishIdRouteImport } from './routes/dishes/$dishId'
import { Route as DishesDishIdEditRouteImport } from './routes/dishes/$dishId_.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuIndexRoute = MenuIndexRouteImport.update({
  id: '/menu/',
  path: '/menu/',
  getParentRoute: () => rootRouteImport,
} as any)
const DishesIndexRoute = DishesIndexRouteImport.update({
  id: '/dishes/',
  path: '/dishes/',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityIndexRoute = AvailabilityIndexRouteImport.update({
  id: '/availability/',
  path: '/availability/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIdRoute = UsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DishesNewRoute = DishesNewRouteImport.update({
  id: '/dishes/new',
  path: '/dishes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DishesDishIdRoute = DishesDishIdRouteImport.update({
  id: '/dishes/$dishId',
  path: '/dishes/$dishId',
  getParentRoute: () => rootRouteImport,
} as any)
const DishesDishIdEditRoute = DishesDishIdEditRouteImport.update({
  id: '/dishes/$dishId_/edit',
  path: '/dishes/$dishId/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dishes/$dishId': typeof DishesDishIdRoute
  '/dishes/new': typeof DishesNewRoute
  '/users/$id': typeof UsersIdRoute
  '/availability/': typeof AvailabilityIndexRoute
  '/dishes/': typeof DishesIndexRoute
  '/menu/': typeof MenuIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/users/': typeof UsersIndexRoute
  '/dishes/$dishId/edit': typeof DishesDishIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dishes/$dishId': typeof DishesDishIdRoute
  '/dishes/new': typeof DishesNewRoute
  '/users/$id': typeof UsersIdRoute
  '/availability': typeof AvailabilityIndexRoute
  '/dishes': typeof DishesIndexRoute
  '/menu': typeof MenuIndexRoute
  '/products': typeof ProductsIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/users': typeof UsersIndexRoute
  '/dishes/$dishId/edit': typeof DishesDishIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dishes/$dishId': typeof DishesDishIdRoute
  '/dishes/new': typeof DishesNewRoute
  '/users/$id': typeof UsersIdRoute
  '/availability/': typeof AvailabilityIndexRoute
  '/dishes/': typeof DishesIndexRoute
  '/menu/': typeof MenuIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/users/': typeof UsersIndexRoute
  '/dishes/$dishId_/edit': typeof DishesDishIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dishes/$dishId'
    | '/dishes/new'
    | '/users/$id'
    | '/availability/'
    | '/dishes/'
    | '/menu/'
    | '/products/'
    | '/profile/'
    | '/users/'
    | '/dishes/$dishId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dishes/$dishId'
    | '/dishes/new'
    | '/users/$id'
    | '/availability'
    | '/dishes'
    | '/menu'
    | '/products'
    | '/profile'
    | '/users'
    | '/dishes/$dishId/edit'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/dishes/$dishId'
    | '/dishes/new'
    | '/users/$id'
    | '/availability/'
    | '/dishes/'
    | '/menu/'
    | '/products/'
    | '/profile/'
    | '/users/'
    | '/dishes/$dishId_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  DishesDishIdRoute: typeof DishesDishIdRoute
  DishesNewRoute: typeof DishesNewRoute
  UsersIdRoute: typeof UsersIdRoute
  AvailabilityIndexRoute: typeof AvailabilityIndexRoute
  DishesIndexRoute: typeof DishesIndexRoute
  MenuIndexRoute: typeof MenuIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  DishesDishIdEditRoute: typeof DishesDishIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu/': {
      id: '/menu/'
      path: '/menu'
      fullPath: '/menu/'
      preLoaderRoute: typeof MenuIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dishes/': {
      id: '/dishes/'
      path: '/dishes'
      fullPath: '/dishes/'
      preLoaderRoute: typeof DishesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability/': {
      id: '/availability/'
      path: '/availability'
      fullPath: '/availability/'
      preLoaderRoute: typeof AvailabilityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dishes/new': {
      id: '/dishes/new'
      path: '/dishes/new'
      fullPath: '/dishes/new'
      preLoaderRoute: typeof DishesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dishes/$dishId': {
      id: '/dishes/$dishId'
      path: '/dishes/$dishId'
      fullPath: '/dishes/$dishId'
      preLoaderRoute: typeof DishesDishIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dishes/$dishId_/edit': {
      id: '/dishes/$dishId_/edit'
      path: '/dishes/$dishId/edit'
      fullPath: '/dishes/$dishId/edit'
      preLoaderRoute: typeof DishesDishIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  DishesDishIdRoute: DishesDishIdRoute,
  DishesNewRoute: DishesNewRoute,
  UsersIdRoute: UsersIdRoute,
  AvailabilityIndexRoute: AvailabilityIndexRoute,
  DishesIndexRoute: DishesIndexRoute,
  MenuIndexRoute: MenuIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  DishesDishIdEditRoute: DishesDishIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
